var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WmsSelectionButton',_vm._b({attrs:{"selections":_vm.newClassSelections,"multiSelect":false,"value":_vm.internalValue},on:{"change":_vm.onChange}},'WmsSelectionButton',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }